import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

import {
  srJobStatusToDriverStatusMapping,
  JOB_STATUS_CANCELLED,
  getJobTypeToActionMapping,
} from 'common/jobConstants';

import ButtonDeprecated, {
  BUTTON_THEME_GREEN_ADOBE,
} from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';
import SrSunSetupOrderDetails from 'client/components/SrSunSetupOrderDetails/SrSunSetupOrderDetails';

import './SrSunSetupDriverOrderPage.less';

const SrSunSetupDriverOrderPage = ({
  jobOrder,
  onComplete,
}) => {
  const {
    id,
    driverId,
    dueDate,
    jobs,
    listing,
    sunlock,
    instructions,
  } = jobOrder;

  return (
    <div>
      <div styleName='card'>
        <div>
          <span styleName='address'>
            {listing.addressStreetDisplay}
            <br />
            {`${listing.addressCity} ${listing.addressStateCode}, ${listing.addressZip}`}
          </span>
          <span styleName='dueDate'>
            Due Date: <span styleName='value'>{moment(dueDate).format('MMM D')}</span>
          </span>
        </div>
      </div>

      <div styleName='card jobs'>
        <span styleName='title'>Jobs</span>
        <div styleName='list'>
          {jobs.filter(({ status }) => status !== JOB_STATUS_CANCELLED).map((job) => (
            <SrLink
              key={job.id}
              styleName='job'
              to={`/sunsetup/drivers/${driverId}/orders/${id}/jobs/${job.id}`}
            >
              <span styleName='jobType'>
                {getJobTypeToActionMapping({ job, listing })}
              </span>
              <br />
              <span styleName={classnames('jobStatus', job.status.toLowerCase())}>
                {srJobStatusToDriverStatusMapping[job.status]}
              </span>
            </SrLink>
          ))}
        </div>
      </div>

      <div styleName='card'>
        <span styleName='title'>
          Order Instructions
        </span>
        <SrBox marginTop='8px'>
          <span styleName='instructions'>
            {instructions || 'No instructions'}
          </span>
        </SrBox>
      </div>

      <SrSunSetupOrderDetails
        listing={listing}
        sunlock={sunlock}
        shouldDisplayAddress={false}
        shouldDisplayPromiseDate={false}
      />

      <SrBox margin='40px 0 0'>
        <ButtonDeprecated
          theme={BUTTON_THEME_GREEN_ADOBE}
          onClick={onComplete}
        >
          Complete Order
        </ButtonDeprecated>
      </SrBox>
    </div>
  );
};

SrSunSetupDriverOrderPage.propTypes = {
  jobOrder: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired,
};

SrSunSetupDriverOrderPage.displayName = 'SrSunSetupDriverOrderPage';

export default SrSunSetupDriverOrderPage;
